export default __webpack_public_path__ + "static/media/Copay Primera.d1df07bf.png";